import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import * as tios from './tios';
import * as simulator from './simulator';

export default class LCDMenuNode extends BaseNode {
    constructor() {
        super();
        this.name = 'Enter LCD Menu';
        this.id = 'node_lcd_menu';
        this.linkedFeature = 'lcd';

        this.inputs = [
            {
                name: 'Enter Menus',
                portId: 'lcd_menu_enter',
                params: [],
            },
        ];
    }

    validate(): ValidationMessage[] {
        const errors: ValidationMessage[] = [];
        const LCDFeature = this.project.getFeature('lcd');
        const GROUPS = LCDFeature.getSettingValue('GROUPS');
        if (GROUPS.length === 0) {
            errors.push({
                featureId: this.getID(),
                messageType: ValidationMessageType.ERROR,
                message: 'LCD must have at least one settings group',
            });
        }
        return errors;
    }

    getCodeBlocks(): CodeBlock[] {
        if (this.project.runtime === 'simulator') {
            return simulator.getCodeBlocks(this);
        }
        return tios.getCodeBlocks(this);
    }
}
